import { ContactPropertyKey } from '@/graphql/generated/types';
import { Formatted } from '@/ui/formatted/formatted.component';
import React, { ReactNode } from 'react';
import { MergeCandidate } from '../types';
import { RelatedUserType } from './utils';

export interface Attribute {
  name: keyof MergeCandidate | ContactPropertyKey;
  label: string;
  render?: (item: Partial<MergeCandidate>) => ReactNode;
  /** If true, values from all candidates are combined with checkboxes instead of a radio pick. */
  isMultiValue?: true;
  getValues?: (item: Partial<MergeCandidate>) => { key: string; value: string }[];
}

export const personAttributes: Attribute[] = [
  {
    name: 'firstName',
    label: 'Vorname',
    render: (item) => item?.firstName,
  },
  { name: 'lastName', label: 'Nachname', render: (item) => item?.lastName },
  {
    name: 'createdAt',
    label: 'CreatedAt',
    render: (item) => <Formatted.Date value={item?.createdAt} />,
  },
  {
    name: ContactPropertyKey.Email,
    label: 'E-Mail',
    isMultiValue: true,
    getValues: (item) =>
      item.contactProperties
        ?.filter((p) => p.key === ContactPropertyKey.Email)
        .map((p) => ({ key: p.key as string, value: p.value })) ?? [],
  },
  {
    name: ContactPropertyKey.Phone,
    label: 'Telefon',
    isMultiValue: true,
    getValues: (item) =>
      item.contactProperties
        ?.filter(
          (p) =>
            p.key === ContactPropertyKey.Mobile ||
            p.key === ContactPropertyKey.Phone,
        )
        .map((p) => ({ key: p.key as string, value: p.value })) ?? [],
  },

  { name: 'gender', label: 'Gender', render: (item) => item?.gender },
  {
    name: 'internalNotes',
    label: 'Interne Notizen',
    render: (item) => item?.internalNotes,
  },

  {
    name: 'address',
    label: 'Adresse',
    render: (item) => (
      <>
        {item?.address?.company && <div>{item?.address?.company} /</div>}
        <> {item?.address?.contactPerson}</>
        <div>{item?.address?.streetAndNumber}</div>
        <div>
          {item?.address?.postalCode} {item?.address?.city}
        </div>
        <div>{item?.address?.country}</div>
      </>
    ),
  },
  {
    name: 'invoiceAddress',
    label: 'Rechnungsadresse',
    render: (item) => (
      <>
        {item?.invoiceAddress?.company && (
          <div>{item?.invoiceAddress?.company} /</div>
        )}
        <> {item?.invoiceAddress?.contactPerson}</>
        <div>{item?.invoiceAddress?.streetAndNumber}</div>
        <div>
          {item?.invoiceAddress?.postalCode} {item?.invoiceAddress?.city}
        </div>
        <div>{item?.invoiceAddress?.country}</div>
      </>
    ),
  },
];

export const customerAttributes: Attribute[] = [
  {
    name: 'customerNumber' as any,
    label: 'Kundennummer',
    render: (item) =>
      item?.user?.__typename === 'Customer'
        ? (item.user as any).customerNumber ?? '–'
        : '–',
  },
  {
    name: 'invoiceEmail' as any,
    label: 'Rechnungs-E-Mail',
    render: (item) =>
      item?.user?.__typename === 'Customer'
        ? (item.user as any).invoiceEmail ?? '–'
        : '–',
  },
];

export const userAttributes: Attribute[] = [];

export const adminAttributes: Attribute[] = [
  /* {
    name: 'roles',
    label: 'Rollen',
    render: (item) =>
      (item?.user as Administrator)?.roles.map((i) => i.name).join(', '),
    canBeMultiple: true,
  }, */
];

export const teacherAttributes: Attribute[] = [
  /* {
    name: 'jobTitle',
    label: 'Berufsbezeichnung',
    render: (item) => (
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{
          __html: (item?.user as Teacher)?.jobTitle || '',
        }}
      />
    ),
  },
  {
    name: 'subjectArea',
    label: 'Fachbereich',
    render: (item) => (
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{
          __html: (item?.user as Teacher)?.subjectArea || '',
        }}
      />
    ),
  }, */
];

export function getAttributesByType(type?: RelatedUserType) {
  const attributes = [...personAttributes];
  if (type === 'Customer') {
    attributes.push(...customerAttributes);
  } else if (type === 'Administrator') {
    attributes.push(...adminAttributes);
  } else if (type === 'Teacher') {
    attributes.push(...teacherAttributes);
  }
  if (type !== undefined) {
    attributes.push(...userAttributes);
  }
  return attributes;
}
